import { render, staticRenderFns } from "./SecondDistributorUserIndex.vue?vue&type=template&id=35e40f5e"
import script from "./SecondDistributorUserIndex.vue?vue&type=script&lang=js"
export * from "./SecondDistributorUserIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports